<template>
  <ContentWrapper>
    <div class="content-heading">
      <div>단축 URL 생성</div>
      <!-- Breadcrumb right aligned-->
      <ol class="breadcrumb ml-auto">
        <li class="breadcrumb-item">
          <a href="#">Home</a>
        </li>
        <li class="breadcrumb-item">
          마켓팅 관리
        </li>
        <li class="breadcrumb-item active">
          <a href="/marketing/shortUrlManagement">단축 URL 생성</a>
        </li>
      </ol>
    </div>
    <!-- 검색  -->
    <div class="card card-default" v-show="data.params.mode=='list'">
      <div class="card-body">
        <div class="form-row align-items-center">
          <!-- 기간검색 -->
          <SchDateRange label="기간" :data="data" @search="search" @reset="reset" />
          <!-- 항목 검색 -->
          <sch-text label="검색어" :data="data" @search="search" @reset="reset"/>
        </div>
      </div>
    </div>
    <!-- // 검색 -->

    <!-- 목록 -->
    <div v-show="data.params.mode=='list'" class="card card-default">
      <div class="card-header mt-2">
        <!-- <span class="text-bold h4">목록</span> -->
        <div class="card-tool float-right" >
          <b-btn class="btn btn-xs btn-outline-info mr-2" variant="outline-primary" style="width:100px;" @click="saveDetail()" >생성</b-btn>
          <b-btn class="btn btn-xs btn-outline-danger mr-2" variant="outline-info mr-2" style="width:100px;" @click="remove('list')" :disabled="!data.enabledDelete">삭제</b-btn>
        </div>
        <ShowCounter label="Show" :data="data" @search="search" />
      </div>
      <div class="card-body">
        <table class="table table-striped table-bordered table-hover">
          <thead>
            <tr>
              <td width="3%" style=""><input type="checkbox" v-model="data.selectAllTeacher" /></td>
              <td width="7%" style="text-align:center" @click="localSort.sort('urlSeq')">No <em class="fa-2s mr-2 fas fa-sort"></em></td>
              <td style="text-align:center">링크명</td>
              <td width="10%" style="text-align:center" @click="localSort.sort('clickTotalCount')">클릭 수 <em class="fa-2s mr-2 fas fa-sort"></em></td>
              <td width="20%" style="text-align:center">등록자ID</td>
              <td width="15%" style="text-align:center" @click="localSort.sort('regDt')">생성날짜 <em class="fa-2s mr-2 fas fa-sort"></em></td>
            </tr>
          </thead>

          <tbody>
            <tr v-show="data.count==0" class="text-center"><td colspan="9">No matching records</td> </tr>
            <tr v-show="data.count!=0" v-for="(item, index) in data.list" :key="index"  > <!--  @click.prevent="edit(item.urlSeq);" -->
              <td style=""><input type="checkbox" v-model="data.selectedTeachers" :value="item.urlSeq" /></td>
              <td class="align-middle text-center" @click="edit(item.urlSeq)">{{data.params.limit*(data.params.page-1) + index+1}}</td>
              <td class="align-middle text-center" @click="edit(item.urlSeq)">{{item.urlName}}</td>
              <td class="align-middle text-center" @click="edit(item.urlSeq)">{{item.clickTotalCount}}</td>
              <td class="align-middle text-center" @click="edit(item.urlSeq)">{{item.regId}}</td>
              <td class="align-middle text-center" @click="edit(item.urlSeq)">{{item.regDt != null ? item.regDt.substr(0,19) : ''}}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="card-footer">
        <div class="d-flex">
          <!--paging component-->
          <Pagenation :data="data" @next="dataAction.next(search)" @prev="dataAction.prev(search)" @first="dataAction.first(search)" @last="dataAction.last(search)" :key="data.params.page"/>
        </div>
      </div>
    </div>
    <!-- // 목록 -->

    <!-- 상세 -->
    <div v-show="data.params.mode=='detail'" class="card card-default book-list">
      <div class="card-body" style="background-color:#fff;">
          <table class="table table-bordered table-hover">
            <tbody>
                <tr>
                    <td class="align-middle text-center">단축 링크명</td>
                    <td class="align-middle text-center" colspan="3">
                        <input type="text" v-model="data.row.urlName" :class="{' form-control':true, 'is-invalid': errors.has('urlName')}"  v-validate="'required|min:2'"  name="urlName" style="width: 100%"  />
                    </td>
                </tr>
                <tr>
                    <td class="align-middle text-center">링크 입력</td>
                    <td class="align-middle text-center" colspan="3">
                    <!-- <td class="align-middle" colspan="2"> -->
                        <input type="text" v-model="data.row.urlOrg" :class="{' form-control':true, 'is-invalid': errors.has('urlOrg')}"  v-validate="'required|min:2'"  name="urlOrg" style="width: 100%"  />
                        <!-- <b-button v-show="!data.row.urlSeq" @click="save()" class="btn btn-b btn-outline-info mr-2" variant="outline-info">생성</b-button>
                        <b-button v-show="data.row.urlSeq"  @click="save()" class="btn btn-b btn-outline-info mr-2" variant="outline-info">수정</b-button> -->
                    </td>
                </tr>
                <tr>
                    <td class="align-middle text-center">단축 링크</td>
                    <td class="align-middle text-left" colspan="3">
                        <!-- <input type="text" v-model="data.row.urlShort" :class="{' form-control':true, 'is-invalid': errors.has('urlShort')}"  v-validate="''"  name="urlShort" style="width: 100%" disabled="true"  /> -->
                        <span style="margin-top: 5px; display: inline-block;">{{ data.row.urlShort }}</span>
                        <b-button v-if="data.row.urlSeq" @click="copyToClipboard()" class="btn btn-b btn-outline-info ml-4 float-right" variant="outline-info">복사하기</b-button>
                    </td>
                </tr>
                <tr>
                    <td class="align-middle text-center">등록자 ID</td>
                    <td class="align-middle">
                        <input type="text" v-model="data.row.regId" :class="{'not-text form-control':true, 'is-invalid': errors.has('regId')}"  v-validate="''"  name="regId" style="width: 100%"  />
                    </td>
                    <td class="align-middle text-center">등록일시</td>
                    <td class="align-middle ">
                         <input type="text" v-model="data.row.regDt" :class="{'not-text form-control':true, 'is-invalid': errors.has('regDt')}"  v-validate="''"  name="regDt" style="width: 100%"  />
                    </td>
                </tr>
                 <tr>
                    <td class="align-middle text-center">수정자 ID</td>
                    <td class="align-middle">
                        <input type="text" v-model="data.row.updId" :class="{'not-text form-control':true, 'is-invalid': errors.has('updId')}"  v-validate="''"  name="updId" style="width: 100%"  />
                    </td>
                    <td class="align-middle text-center">수정일시</td>
                    <td class="align-middle ">
                         <input type="text" v-model="data.row.updDt" :class="{'not-text form-control':true, 'is-invalid': errors.has('updDt')}"  v-validate="''"  name="updDt" style="width: 100%"  />
                    </td>
                </tr>
            </tbody>
        </table>

        <!-- echarts -->
        <div v-show="data.row.urlSeq" class="mt-5" style="margin: 0 90px 0 90px;">
        <!-- </div>
        <div v-show="data.row.urlSeq" class="" style="margin: 0 90px 0 90px;"> -->
          <div class="card-header mb-2">
            <div class="card-tool float-right">
                <b-btn class="btn btn-xs btn-outline-info" variant="outline-primary" style="width:100px;" @click="charData_excelDownload()" >다운로드</b-btn>
            </div>
          </div>
          <br>
          <span class="h4 float-left ml-2">총 {{data.row.clickTotalCount}} 클릭 수</span>
          <div style="btn-group; margin: 0 15px 0 0;">
            <b-btn class="btn btn-b float-right" @click="chartData_mode('M', $event.target)">월간</b-btn>
            <b-btn class="btn btn-b float-right mr-2 active" @click="chartData_mode('D', $event.target)">일간</b-btn>
          </div>
          <table class="table">
            <colgroup> 
              <col style="width: 5%;"/> 
              <col style="width: 90%;"/> 
              <col style="width: 5%;"/> 
            </colgroup> 
            <tbody>
                <tr>
                    <td class="align-middle text-right h1" style="border-top: none; border-bottom: none;">
                      <b-btn class="btn btn-b float-left h1" style="height:300px; font-size: 2.25rem;" @click="chartData_prev()" :disabled="chartData_prev_disabled()">{{chartData_prev_disabled() ? '' : '«'}}</b-btn>
                    </td>
                    <td class="align-middle text-center" style="border-top: none; border-bottom: none;">
                      <chart theme="custom" :options="chartData.barData" ref="chart2" auto-resize></chart>
                    </td>
                    <td class="align-middle text-left h1" style="border-top: none; border-bottom: none;">
                      <b-btn class="btn btn-b float-right h1 mr-1" style="height:300px; font-size: 2.25rem;" @click="chartData_next()" :disabled="chartData_next_disabled()">{{chartData_next_disabled() ? '' : '»'}}</b-btn>
                    </td>
                </tr>
            </tbody>
          </table>
        </div>

        <div class="footer mt-3">
          <div class="float-right">
              <b-button v-show="!!data.row.urlSeq" @click="remove('detail')" class="btn btn-b btn-outline-danger mr-2" variant="outline-info mr-2">삭제</b-button>
              <b-button @click="save()" class="btn btn-b btn-info mr-2" variant="info mr-2">{{data.row.urlSeq == null ? '생성' : '수정'}}</b-button>
              <b-button @click="search()" class="btn btn-b btn-outline-info mr-2" variant="outline-info mr-2">목록</b-button>
          </div>
        </div>
      </div>
    </div>
  </ContentWrapper>
</template>
<style scoped>
  /* .quill-editor.is-invalid, .vdp-datepicker.is-invalid { */
  .is-invalid {
    border:1px solid #f05050
  }
</style>
<style>
    .echarts {
        width: 100%;
        height: 300px;
    }
</style>
<script>
import Vue from 'vue'
import { reactive, ref, computed, onMounted, onUnmounted ,onBeforeMount, nextTick} from '@vue/composition-api'
import {dataObject} from "@/utils/Constants";
import {getShortUrlList,getShortUrlDetail,saveShortUrl,deleteShortUrl,clickStatExcelDownload} from "@/api/marketing/ShortUrlApi";
import {getSsoAdmList} from "@/api/sso/SsoAdmApi";
import Pagenation from "@/components/Common/Pagenation";
import {TableActionClass} from "@/utils/TableActionClass";
import SchDateRange from "../../components/Common/SchDateRange";
import SchText from "../../components/Common/SchText";
import ShowCounter from "../../components/Common/ShowCounter";
// import Datepicker from 'vuejs-datepicker'
import swal from 'sweetalert2'
import Axios from 'axios';
import moment from 'moment';

// 로딩처리
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';

// import draggable from 'vuedraggable'
// 목차/차시/파일

// import VueQuillEditor from 'vue-quill-editor'

// import 'quill/dist/quill.core.css' // import styles
// import 'quill/dist/quill.snow.css' // for snow theme
// import 'quill/dist/quill.bubble.css' // for bubble theme
import vueMoment from 'vue-moment' 

Vue.use(vueMoment)
// Vue.use(VueQuillEditor, /* { default global options } */)

// echarts
import ECharts from "vue-echarts/components/ECharts.vue";
import theme from "../../components/Common/theme.json";
import { initial, serieObject, barData } from "../../components/Common/bar";
import "echarts/lib/chart/bar";
import "echarts/theme/dark";

ECharts.registerTheme("custom", theme);
export default {
  components: {SchDateRange, SchText, ShowCounter, Pagenation,  Loading, chart: ECharts},

  setup(props, {root}){
    const searchOptionsYn = ref([
      {text: 'Y', value:'Y'},
      {text: 'N', value:'N'},
    ]);
    const _dataObject = _.cloneDeep(dataObject);
    _dataObject.schOptions = [
      // {text: '전체', value:''},
      {text: '링크명', value:'name'},
      {text: '등록자 ID', value:'regId'},
    ];
    _dataObject.selectedTeachers = [];
    _dataObject.selectAllTeacher = computed({
      get() {
        return data.list.length && data.selectedTeachers.length && data.list.every(item => data.selectedTeachers.includes(item.urlSeq));
      },
      set(newValue) {
        let selected = [];
        if (newValue) {
          data.list.forEach(item => {
            selected.push(item.urlSeq);
          });
        }
        data.selectedTeachers = selected;
      }
    });
    _dataObject.enabledDelete = computed(() => {
        return data.list.length && data.selectedTeachers.length && data.list.some(item => data.selectedTeachers.includes(item.urlSeq));
    });
    
    const data = reactive(_dataObject)

    // echarts data
    const chartDataPer = 10; // 챠트당 데이타 갯수.
    const chartData = reactive({
      barData,
      range: {
        minDate  : '0000-00-00', // 일별:'YYYY-MM-DD'
        maxDate  : moment().format('YYYY-MM-DD'), // 일별:'YYYY-MM-DD'
        minDateM  : '0000-00-01', // 월별:'YYYY-MM-01'
        maxDateM  : moment().format('YYYY-MM-01'), // 월별:'YYYY-MM-01'
      },
      params: {
        mode: 'D', // 일별('D'), 월별('M')
        startDate: moment().subtract(chartDataPer-1, 'days').format('YYYY-MM-DD'), // 일별:'YYYY-MM-DD'
        endDate  : moment().format('YYYY-MM-DD'), // 일별:'YYYY-MM-DD'
        startDateM: moment().subtract(chartDataPer-1, 'months').format('YYYY-MM-01'), // 월별:'YYYY-MM-01'
        endDateM  : moment().format('YYYY-MM-01'), // 월별:'YYYY-MM-01'
      },
    });
    const chartData_range = (minDate, maxDate) => {
      if (minDate) {
        const min = moment(minDate, 'YYYY-MM-DD');
        chartData.range.minDate = min.format('YYYY-MM-DD');
        chartData.range.minDateM = min.format('YYYY-MM-01');
      }
      if (maxDate) {
        const max = moment(maxDate, 'YYYY-MM-DD');
        chartData.range.maxDate = max.format('YYYY-MM-DD');
        chartData.range.maxDateM = max.format('YYYY-MM-01');
      }
    };
    const chartData_set = (datas) => {
      datas = datas || '0,0,0,0,0,0,0,0,0,0';
      if (chartData.params.mode == 'D') {
        let startDate = moment(chartData.params.startDate, 'YYYY-MM-DD');
        const xAxis = [startDate.format('YYYY년MM월DD일')];
        const dataList = datas.split(',');
        let year = startDate.year();
        for (let i = 1; i < dataList.length; i++) {
          startDate = startDate.add(1, 'days');
          if (year != startDate.year()) {
            year = startDate.year();
            xAxis.push(startDate.format('YYYY년MM월DD일'));
          } else {
            xAxis.push(startDate.format('MM월DD일'));
          }
        }
        barData.xAxis.data = xAxis;
        barData.series = [serieObject({ title: "클릭 수", data: dataList })];
      } else if (chartData.params.mode == 'M') {
        let startDate = moment(chartData.params.startDateM, 'YYYY-MM-DD');
        const xAxis = [startDate.format('YYYY년MM월')];
        const dataList = datas.split(',');
        let year = startDate.year();
        for (let i = 1; i < dataList.length; i++) {
          startDate = startDate.add(1, 'months');
          if (year != startDate.year()) {
            year = startDate.year();
            xAxis.push(startDate.format('YYYY년MM월'));
          } else {
            xAxis.push(startDate.format('MM월'));
          }
        }
        barData.xAxis.data = xAxis;
        barData.series = [serieObject({ title: "클릭 수", data: dataList })];
      }
    }
    chartData_set(); // init
    const chartData_prev_disabled = () => {
      return chartData.params.mode == 'D' ? chartData.params.startDate <= chartData.range.minDate : chartData.params.startDateM <= chartData.range.minDateM;
    }
    const chartData_next_disabled = () => {
      return chartData.params.mode == 'D' ? chartData.params.endDate >= chartData.range.maxDate : chartData.params.endDateM >= chartData.range.maxDateM;
    }
    const chartData_prev = () => {
      if (chartData.params.mode == 'D') {
        chartData.params.startDate = moment(chartData.params.startDate, 'YYYY-MM-DD').subtract(chartDataPer, 'days').format('YYYY-MM-DD');
        chartData.params.endDate = moment(chartData.params.endDate, 'YYYY-MM-DD').subtract(chartDataPer, 'days').format('YYYY-MM-DD');
      } else if (chartData.params.mode == 'M') {
        chartData.params.startDateM = moment(chartData.params.startDateM, 'YYYY-MM-DD').subtract(chartDataPer, 'months').format('YYYY-MM-DD');
        chartData.params.endDateM = moment(chartData.params.endDateM, 'YYYY-MM-DD').subtract(chartDataPer, 'months').format('YYYY-MM-DD');
      }
      loadDetailData(data.row.urlSeq);
    }
    const chartData_next = () => {
      if (chartData.params.mode == 'D') {
        chartData.params.startDate = moment(chartData.params.startDate, 'YYYY-MM-DD').add(chartDataPer, 'days').format('YYYY-MM-DD');
        chartData.params.endDate = moment(chartData.params.endDate, 'YYYY-MM-DD').add(chartDataPer, 'days').format('YYYY-MM-DD');
      } else if (chartData.params.mode == 'M') {
        chartData.params.startDateM = moment(chartData.params.startDateM, 'YYYY-MM-DD').add(chartDataPer, 'months').format('YYYY-MM-DD');
        chartData.params.endDateM = moment(chartData.params.endDateM, 'YYYY-MM-DD').add(chartDataPer, 'months').format('YYYY-MM-DD');
      }
      loadDetailData(data.row.urlSeq);
    }
    const chartData_mode = (mode, target) => {
      if (target) {
          let $el = $(target);
          if (!$el.hasClass('active')) {
              $el.siblings().removeClass("active");
              $el.addClass('active');

              chartData.params.mode = mode;
              loadDetailData(data.row.urlSeq);
          }
      }
    }
    const charData_excelDownload = async () => {
      let _params = {
        urlSeq: data.row.urlSeq,
      }
      let result = await clickStatExcelDownload(_params, `단축링크통계(${data.row.urlName})`);
    }

    const loadData = async () => {
      data.params.adminYn = 'Y';
      let result = await getShortUrlList(data.params);
      data.list = result.data;
      data.count = result.count;
      data.row = {};
      data.params.mode = 'list';
      root.$_localSort.set(data.list);
    }
    const loadDetailData = async (_seq) => {
      let _params = {
        urlSeq: _seq,
        clickCountMode: chartData.params.mode,
        clickCountStartDate: chartData.params.mode=='D' ? chartData.params.startDate : chartData.params.startDateM,
        clickCountEndDate: chartData.params.mode=='D' ? chartData.params.endDate : chartData.params.endDateM,
      }
      let result = await getShortUrlDetail(_params);
      data.list = []
      data.row = result.data;
      data.params.mode = 'detail';
      beautifyData();

      // echarts barData setting.
      chartData_range(data.row.regDt);
      chartData_set(data.row.clickCountList);
    }

    const beautifyData = () => {
      data.row.regDt = data.row.regDt ? data.row.regDt.substr(0,19) : '';
      data.row.updDt = data.row.updDt ? data.row.updDt.substr(0,19) : '';
      if (data.row.urlShort && (
          window.location.host.includes('test.') // staging
          || window.location.host.includes('testadmin.') // staging
          || window.location.host.includes('3.34.40.157') // staging
          || window.location.host.includes('localhost')))
      {
        data.row.urlShort = data.row.urlShort.slice(0, 8) + 'test.' + data.row.urlShort.slice(8);
      }
    }

    const saveDetail = () =>{
      data.params.mode = "detail";

      data.row.urlSeq = null;
      data.row.urlName = '';
      data.row.urlOrg = '';
      data.row.urlShort = '';
      data.row.regId = '';
      data.row.updId = '';
      data.row.regDt = '';
      data.row.updDt = '';
      data.row.clickTotalCount = '';

      data.row.clickCountMode = '';
      data.row.clickCountStartDate = '';
      data.row.clickCountEndDate = '';
      data.row.clickCountList = [];
    }

    const copyToClipboard = () => {
      // window.navigator.clipboard.writeText(data.row.urlShort).then(() => {
      //   alert("복사 완료!");
      // });
      var t = document.createElement('textarea');
      document.body.appendChild(t);
      t.value = data.row.urlShort;
      t.select();
      document.execCommand('copy');
      document.body.removeChild(t);
      alert("복사 완료!");
    }
    
    onMounted(loadData)

    return{
      chartData, // echarts
      chartData_prev_disabled, // echarts
      chartData_next_disabled, // echarts
      chartData_prev, // echarts
      chartData_next, // echarts
      chartData_mode, // echarts
      charData_excelDownload, // echarts
      searchOptionsYn,
      dataObject,
      _dataObject,
      data,
      loadData,
      loadDetailData,
      beautifyData,
      saveDetail,
      copyToClipboard,
      ...methods(),
      dataAction: new TableActionClass(data),
      localSort:root.$_localSort
    }
  },
}

function methods() {
  var context = {};

   // 목록
  async function search() {
    this.loadData();
  }

  // 상세
  async function edit(_seq){
    this.loadDetailData(_seq);
  }

   // 저장
  async function save(type) { 
    let saveTitle =  this.data.row.urlSeq==null?'생성' : '수정';

    const isValid = await this.$validator.validateAll();
    if (!isValid) {
      alert('필수 입력 항목을 확인해주세요.');
      return false;
    }

    if (!confirm(saveTitle+" 하시겠습니까?")) {
      // 취소(아니오) 버튼 클릭 시 이벤트
      return false;
    }
    else{
      // 확인(예) 버튼 클릭 시 이벤트
      var formData = new FormData();
      
      if(this.data.row.urlSeq !=null){
          formData.append("urlSeq", this.data.row.urlSeq);
          formData.append("urlName", this.data.row.urlName);
          formData.append("urlOrg", this.data.row.urlOrg);

      }else{
          formData.append("urlName", this.data.row.urlName);
          formData.append("urlOrg", this.data.row.urlOrg);
      }
      let result = await saveShortUrl(formData).then((result) => {
        if(result.data){
          console.log('save success', result.data);
          this.data.row = result.data;
          this.beautifyData();
          alert(saveTitle+'이 완료되었습니다.');
        }
      }); 
    }
  }

  async function remove(delType) {
    if (!confirm('단축 링크를 삭제하시겠습니까?')) {
      return false;
    }
    const params = [];
    if (delType == 'detail') {
      params.push({ urlSeq : this.data.row.urlSeq });
    } else if (delType == 'list') {
      this.data.list.forEach(item => {
        if (this.data.selectedTeachers.includes(item.urlSeq)) params.push({ urlSeq : item.urlSeq });
      });
    }
    if (params.length > 0) {
      const result = await deleteShortUrl(params);
      if(result.data){
        alert('삭제가 완료되었습니다.');
        this.search(); // 목록가기
      }
    }
  }

  // 초기화
  async function reset(){
    this.data.params.mode="list";
  }

  return {
    search,
    remove,
    edit,
    reset,
    save,
  }
}

</script>
